import Navbar from "../../NavBar/Navbar"
import SideBar from "../../NavBar/Sidebar"
import PrevisualizarContent from "./PrevisualizarContent"

interface childsProps{
    logout: () => void
}


const Previsualizar: React.FC<childsProps> = ({logout}) => {

    return(
    <div className="sidebar-noneoverflow">
        <Navbar logout={logout}/>
    
        <div className="main-container" id="container">
            <SideBar/>
            
            <PrevisualizarContent/>
        </div>

    </div>
    )
}


export default Previsualizar